export default __webpack_public_path__ + "static/ombralsun-5-9da6d3ae0043b54c196849f7b8401701.jpg";